// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HomePage_wrapper__2FIzi","backgroundImage":"HomePage_backgroundImage__bTYFL","background":"HomePage_background__iSGOR","myScrollPanel":"HomePage_myScrollPanel__DxpFi"};